module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-inner-wrap"
  }, [_c('div', {
    staticClass: "accordion-inner-mask"
  }, [_c('div', {
    staticClass: "accordion-inner-content"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.row_title)
    },
    on: {
      "click": _vm.toggleOpen
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.row_text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-wrap"
  }, _vm._l((_vm.data.row_downloads), function(icons, index) {
    return _c('IconDownload', {
      key: index,
      attrs: {
        "name": _vm.data.row_downloads[index].download_text,
        "link": _vm.data.row_downloads[index].download_link
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('p', {
    on: {
      "click": _vm.toggleOpen
    }
  }, [_vm._v("| " + _vm._s(_vm.$t("message.read_more")))])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-inner-icon"
  }, [_c('div', {
    staticClass: "icon-wrap",
    on: {
      "click": _vm.toggleOpen
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-989e9dc0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AccordionInner.vue
// module id = 355
// module chunks = 0